import { Navigate } from "react-router-dom";
import { authRouteConfig } from "./AuthRoutes";
import RouterComponent from "./RouterComponent";
import Error403 from "@app/ErrorPages/Error403";
import { errorPagesConfigs } from "./ErrorPagesRoutes";
import { authorizedRoutes } from "./AuthorizedRoutes";
import {
  IAnonymousStructure,
  IAuthorizedStructure,
  IAuthStructure,
} from "@lib/types/Routes";

export const publicFallback = (authRouteConfig.find((v) =>
  v?.path.includes("signin"),
)?.path || "") as string;

const authorizedStructure: IAuthorizedStructure = {
  fallbackPath: "/",
  unAuthorizedComponent: <Error403 />,
  routes: authorizedRoutes,
};

const authStructure: IAuthStructure = {
  fallbackPath: publicFallback,
  routes: authRouteConfig,
};

const anonymousStructure: IAnonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: "/",
      element: <RouterComponent />,
    },
    {
      path: "*",
      element: <Navigate to="/error-pages/error-404" />,
    },
  ]),
};

export { authorizedStructure, authStructure, anonymousStructure };
